import React, { useEffect } from "react";
import Routers from "./Route";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import { updateFavicon } from "./utils/faviconHelper";

const App = () => {
  useEffect(() => {
    // Update favicon on app load
    updateFavicon();
  }, []);

  return (
    <div className="App">
      <CustomizerProvider>
        <Routers />
      </CustomizerProvider>
    </div>
  );
};

export default App;
